// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2022/8/18
// +-------------------------------------------------------------
// |Time: 14:02
// +-------------------------------------------------------------
import request from "@/utils/apiRequest";

export const menuList = () =>
    request({
        url: '/menu/menu-list',
        method: 'post',
        data: {},
    })

export const ruleList = () =>
    request({
        url: '/menu/rule-list',
        method: 'post',
        data: {},
    })
